import { BaseModel } from '../base-model';

export interface IDemandPerson {
  AddressA?: string;
  AddressB?: string;
  AddressTitle?: string;
  CompanyName?: string;
  Email?: string;
  Fax?: string;
  FirstName?: string;
  Id?: number;
  Language?: number;
  LetterTitle?: string;
  MobilePhone?: string;
  Name?: string;
  PhoneBusiness?: string;
  PhonePrivate?: string;
  Reference?: string;
  IsDeleted?: boolean;
  NeverSendMail?: boolean;
}
export class DemandPerson extends BaseModel<IDemandPerson> implements IDemandPerson {
  AddressA: string;
  AddressB: string;
  AddressTitle: string;
  CompanyName: string;
  Email: string;
  Fax: string;
  FirstName: string;
  Id: number;
  Language: number;
  LetterTitle: string;
  MobilePhone: string;
  Name: string;
  PhoneBusiness: string;
  PhonePrivate: string;
  Reference: string;
  IsDeleted: boolean;
  NeverSendMail: boolean;
  /**
   *
   */
  constructor(option?: IDemandPerson) {
    super(option);
  }
}